import React, { useRef, useEffect } from 'react';

export default function AutoGrowTextarea({ value, onChange, ...props }) {
  const textareaRef = useRef(null);

  const handleInput = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set to scrollHeight
    }
  };

  useEffect(() => {
    handleInput(); // Adjust height on mount or value change
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      onInput={handleInput}
      spellCheck={false}
      rows={1}
      style={{resize: 'none', overflowY: 'auto', border: 'none', outline: 'none', fontSize: props.fontSize+'px', color: '#111', width: '100%', padding: '5px', minHeight: '20px', maxHeight: '200px'}}
      {...props}
    />
  );
}
